/**
 * Types shared with the server's RBAC module.
 *
 * §34: the exact 18-permission baseline. Kept in sync with rbac/authorize.ts —
 * a mismatch would let the admin matrix display a permission the server does not
 * enforce, which §97 forbids ("never display a capability that cannot be
 * verified"). The audit gate cross-checks the two lists.
 */

export const PERMISSIONS = [
  'users.read', 'users.create', 'users.update', 'users.disable',
  'roles.read', 'roles.manage',
  'records.read', 'records.create', 'records.update', 'records.delete',
  'calendar.read', 'calendar.manage',
  'routes.read', 'routes.manage',
  'integrations.manage', 'audit.read', 'security.manage', 'configuration.manage',
] as const;

export type Permission = (typeof PERMISSIONS)[number];

/** §35 authorization scopes and their operator-facing labels. */
export type ScopeKind = 'own' | 'team' | 'region' | 'org';

export const SCOPE_LABELS: Record<ScopeKind, string> = {
  own: 'Own records',
  team: 'Assigned team',
  region: 'Assigned region',
  org: 'Organization-wide',
};
